import React from 'react';
import MediumButton from '../ui/MediumButton';
import typography from '../../utils/typography';
import colors from '../../utils/colors';
import { ChevronLeftIcon, EditIcon, ShareIcon, ChevronDownIcon, ChevronRightIcon } from '../../utils/icons';


const AddIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M8 2C7.52661 2 7.14286 2.38376 7.14286 2.85714V7.14286L2.85714 7.14286C2.38376 7.14286 2 7.52661 2 8C2 8.47339 2.38376 8.85714 2.85714 8.85714H7.14286V13.1429C7.14286 13.6162 7.52661 14 8 14C8.47339 14 8.85714 13.6162 8.85714 13.1429V8.85714H13.1429C13.6162 8.85714 14 8.47339 14 8C14 7.52661 13.6162 7.14286 13.1429 7.14286L8.85714 7.14286V2.85714C8.85714 2.38376 8.47339 2 8 2Z"
      fill="#FAF7F5"
    />
  </svg>
);


const WorkspaceHeader = ({
  title = "My Workspace",
  avatar = "workspace.png",
  onBack,
  onEdit,
  onAddAudio,
  onShare,
  isCollapsed = false,
  className = "",
  onBackToList,
  selectedMode = 'Chat'
}) => {
  return (
    <div className={`flex items-center justify-between w-full ${className}`}>
      {/* Breadcrumb: Workspaces or Chats */}
      <div className="flex items-center gap-1">
        <button
          onClick={onBackToList}
          className="hover:opacity-80 transition-opacity"
          style={{ ...typography.medium.title, color: colors.text.primary }}
        >
          {selectedMode === 'Chat' ? 'Chats' : 'Workspaces'}
        </button>
        <div className="w-4 h-4" style={{ color: colors.text.primary }}>
          <ChevronRightIcon />
        </div>
        <p style={{ ...typography.medium.regular, color: colors.text.inactive }}>
          {title}
        </p>
      </div>

      {/* Share Button */}
      <MediumButton
        variant="secondary"
        text="Share"
        leftIcon={<ShareIcon />}
        onClick={onShare}
      />
    </div>
  );
};

export default WorkspaceHeader;